/* Affiliate application scroll, partner sign-in, and silent creator loops. */
(function () {
  'use strict';
  if (window.__fizzyAffiliateOrbit) return;
  window.__fizzyAffiliateOrbit = true;
  var instances = new Map();

  function init(root) {
    if (instances.has(root)) return;
    var aborter = new AbortController();
    var signal = aborter.signal;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var dialog = root.querySelector('.afo-signin');
    var signIn = root.querySelector('[data-afo-signin]');
    var visual = root.querySelector('.afo-visual');
    var videos = Array.from(root.querySelectorAll('[data-afo-video]'));
    var visible = false;
    var saveData = Boolean(navigator.connection && navigator.connection.saveData);
    var observer;

    function syncMotion() {
      var paused = saveData || reduced.matches || !visible || document.hidden || (dialog && dialog.open);
      root.classList.toggle('afo-motion-paused', paused);
      videos.forEach(function (video) {
        if (paused) {
          video.pause();
          video.classList.remove('is-playing');
          return;
        }
        if (!video.getAttribute('src')) video.src = video.dataset.src;
        video.muted = true;
        var play = video.play();
        if (play && play.catch) play.catch(function () {
          video.classList.remove('is-playing');
        });
      });
    }

    videos.forEach(function (video) {
      video.addEventListener('playing', function () {
        // An autoplay promise may resolve after the hero has left the viewport.
        if (saveData || reduced.matches || !visible || document.hidden || (dialog && dialog.open)) {
          video.pause();
          return;
        }
        video.classList.add('is-playing');
      }, { signal: signal });
      video.addEventListener('error', function () {
        video.classList.remove('is-playing');
      }, { signal: signal });
    });

    var apply = root.querySelector('[data-afo-apply]');
    if (apply) apply.addEventListener('click', function (event) {
      var href = event.currentTarget.getAttribute('href');
      if (!href || href.charAt(0) !== '#' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var target = document.getElementById(href.slice(1));
      if (!target) return;
      event.preventDefault();
      target.focus({ preventScroll: true });
      target.scrollIntoView({ behavior: reduced.matches ? 'instant' : 'smooth', block: 'start' });
      if (location.hash !== href) history.pushState(history.state, '', href);
    }, { signal: signal });

    if (dialog && typeof dialog.showModal === 'function') {
      signIn.hidden = false;
      signIn.addEventListener('click', function () {
        window.fizzyPopupMotion.open(dialog);
        syncMotion();
      }, { signal: signal });
      dialog.querySelector('[data-afo-close]').addEventListener('click', function () {
        window.fizzyPopupMotion.close(dialog);
      }, { signal: signal });
      dialog.addEventListener('close', function () {
        signIn.focus({ preventScroll: true });
        syncMotion();
      }, { signal: signal });
      // Safari fallback for native dialog light-dismiss.
      if (!('closedBy' in HTMLDialogElement.prototype)) {
        dialog.addEventListener('click', function (event) {
          if (event.target !== dialog) return;
          var rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) window.fizzyPopupMotion.close(dialog);
        }, { signal: signal });
      }
    }

    reduced.addEventListener('change', syncMotion, { signal: signal });
    document.addEventListener('visibilitychange', syncMotion, { signal: signal });
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        syncMotion();
      }, { threshold: 0.1 });
      observer.observe(visual);
    } else {
      visible = true;
    }
    syncMotion();

    instances.set(root, function () {
      aborter.abort();
      if (observer) observer.disconnect();
      if (dialog && dialog.open) window.fizzyPopupMotion.close(dialog);
      videos.forEach(function (video) { video.pause(); });
      instances.delete(root);
    });
  }

  function scan(scope) {
    if (scope.matches && scope.matches('[data-afo-section]')) init(scope);
    scope.querySelectorAll('[data-afo-section]').forEach(init);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (cleanup, root) {
      if (event.target === root || event.target.contains(root)) cleanup();
    });
  });
}());
